























import router from "@/router/router";

import { Component, Vue } from "vue-property-decorator";
import { SchedulingModule } from "@/store/modules/SchedulingModule";

import {
  SchedulingSettings,
  PlanningBoardSettings,
  WorkingHoursSettings,
  TravelTimeSettings,
  PlanningControlSettings,
} from "@/data/models/SchedulingSettings";

import {
  loadSchedulingSettings,
  saveSchedulingSettings,
} from "@/data/repository/SchedulingSettingsRepository";

import PlanningBoardSettingsComponent from "./PlanningBoardSettings.vue";
import TravelTimeSettingsComponent from "./TravelTimeSettings.vue";
import PlanningControlSettingsComponent from "./PlanningControl.vue";
import {
  localiseSchedulingSettingsSection,
  SchedulingSettingsSection,
} from "@/data/models/SchedulingSettingsSection";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";

@Component({
  components: {
    "planning-board-settings": PlanningBoardSettingsComponent,
    "travel-time-settings": TravelTimeSettingsComponent,
    "planning-control-settings": PlanningControlSettingsComponent,
  },
})
export default class SchedulingSettingsComponent extends Vue {
  schedulingSettingsSection = SchedulingSettingsSection.PLANNING_BOARD;

  get showPlanningBoardSettings() {
    return (
      this.schedulingSettingsSection == SchedulingSettingsSection.PLANNING_BOARD
    );
  }

  get showTravelTimeSettings() {
    return (
      this.schedulingSettingsSection ==
      SchedulingSettingsSection.GEOCODING_AND_TRAVEL_TIMES
    );
  }

  get showPlanningControlSettings() {
    return (
      this.schedulingSettingsSection ==
      SchedulingSettingsSection.PLANNING_CONTROL
    );
  }

  get workingHoursSettings() {
    return this.schedulingSettings.workingHoursSettings;
  }

  set workingHoursSettings(workingHoursSettings: WorkingHoursSettings) {
    this.schedulingSettings = {
      ...this.schedulingSettings,
      workingHoursSettings: workingHoursSettings,
    };
  }

  get travelTimeSettings() {
    return this.schedulingSettings.travelTimeSettings;
  }

  set travelTimeSettings(travelTimeSettings: TravelTimeSettings) {
    this.schedulingSettings = {
      ...this.schedulingSettings,
      travelTimeSettings: travelTimeSettings,
    };
  }

  get planningBoardSettings() {
    return this.schedulingSettings.planningBoardSettings;
  }

  set planningBoardSettings(planningBoardSettings: PlanningBoardSettings) {
    this.schedulingSettings = {
      ...this.schedulingSettings,
      planningBoardSettings: planningBoardSettings,
    };
  }

  get planningControlSettings() {
    return this.schedulingSettings.planningControlSettings;
  }

  set planningControlSettings(
    planningControlSettings: PlanningControlSettings
  ) {
    this.schedulingSettings = {
      ...this.schedulingSettings,
      planningControlSettings: planningControlSettings,
    };
  }

  schedulingSettings = { ...SchedulingModule.schedulingSettings };

  async mounted() {
    const baseTitle = this.$t("pages.settings").toString();

    this.schedulingSettingsSection = router.currentRoute.query[
      "section"
    ] as SchedulingSettingsSection;

    ToolbarContentModule.setToolbarTitle(
      baseTitle + " > " +
      localiseSchedulingSettingsSection(
        this,
        this.schedulingSettingsSection
      ).toString()
    );

    const schedulingSettings = await loadSchedulingSettings();

    SchedulingModule.setSchedulingSettings(schedulingSettings);

    this.schedulingSettings = { ...schedulingSettings };
  }

  async onSave() {
    const newSettings: SchedulingSettings = {
      ...this.schedulingSettings,
    };

    await saveSchedulingSettings(newSettings);

    SchedulingModule.setSchedulingSettings(newSettings);
    SchedulingModule.updateOccupiedTimeDataForScheduledTasks();

    router.back();
  }
}
